import { createAction } from '@reduxjs/toolkit';
import { PaginationType } from 'commons/framework/type';
import { AscType, FileType, SortType } from 'commons/constants/type';
import {
  REQUEST_LOGIN,
  REQUEST_LOGIN_SUCCESS,
  REQUEST_LOGIN_FAILURE,
  REQUEST_LOGOUT,
  REQUEST_LOGOUT_SUCCESS,
  REQUEST_LOGOUT_FAILURE,
  REQUEST_AUTHENTICATION,
  REQUEST_AUTHENTICATION_FAILURE,
  REQUEST_AUTHENTICATION_SUCCESS,
  REQUEST_STORAGE_LIST_SUCCESS,
  REQUEST_STORAGE_LIST_FAILURE,
  REQUEST_STORAGE_LIST,
  REQUEST_CATEGORY_LIST,
  REQUEST_CATEGORY_LIST_FAILURE,
  REQUEST_CATEGORY_LIST_SUCCESS,
  OPEN_MODAL,
  CLOSE_MODAL,
  REQUEST_SCRIPT_LIST,
  REQUEST_SCRIPT_LIST_FAILURE,
  REQUEST_SCRIPT_LIST_SUCCESS,
  REQUEST_WKBL_VIDEO_LIST,
  REQUEST_WKBL_VIDEO_LIST_FAILURE,
  REQUEST_WKBL_VIDEO_LIST_SUCCESS,
  REQUEST_CODE_LIST,
  REQUEST_CODE_LIST_FAILURE,
  REQUEST_CODE_LIST_SUCCESS,
  REQUEST_WKBL_SCRIPT_LIST,
  REQUEST_WKBL_SCRIPT_LIST_FAILURE,
  REQUEST_WKBL_SCRIPT_LIST_SUCCESS,
  REQUEST_WKBL_SPECIAL_VIDEO_LIST,
  REQUEST_WKBL_SPECIAL_VIDEO_LIST_FAILURE,
  REQUEST_WKBL_SPECIAL_VIDEO_LIST_SUCCESS,
  CHANGE_VIDEO_IN_TIME,
  CHANGE_VIDEO_OUT_TIME,
  INIT_VIDEO,
  REQUEST_PREFERENCE_LIST,
  REQUEST_PREFERENCE_LIST_FAILURE,
  REQUEST_PREFERENCE_LIST_SUCCESS,
  THROW_ERROR,
  CLEAR_ERROR,
  CHANGE_WKBL_VIDEO_SEASON,
  CHANGE_WKBL_VIDEO_GAME_DATE_FROM,
  CHANGE_WKBL_VIDEO_GAME_DATE_TO,
  CHANGE_WKBL_VIDEO_GAME_TYPE,
  CHANGE_WKBL_VIDEO_PAGE,
  CHANGE_WKBL_VIDEO_SORT,
  CHANGE_WKBL_VIDEO_ASC,
  CHANGE_WKBL_VIDEO_RETURN_COUNT,
  CHANGE_WKBL_SCRIPT_PAGE,
  CHANGE_WKBL_SCRIPT_SORT,
  CHANGE_WKBL_SCRIPT_RETURN_COUNT,
  CLEAR_WKBL_VIDEO_LIST,
  CLEAR_WKBL_SPECIAL_VIDEO_LIST,
  CLEAR_WKBL_SCRIPT_LIST,
  CHANGE_WKBL_SPECIAL_VIDEO_ASC,
  CHANGE_WKBL_SPECIAL_VIDEO_PAGE,
  CHANGE_WKBL_SPECIAL_VIDEO_SORT,
  CHANGE_WKBL_SPECIAL_VIDEO_RETURN_COUNT,
  REQUEST_TEAM_LIST,
  REQUEST_TEAM_LIST_FAILURE,
  REQUEST_TEAM_LIST_SUCCESS,
  CHANGE_VIDEO_DURATION,
  CHANGE_VIDEO_CURRENT_TIME,
  REQUEST_SCRIPT_LIST_BY_SCROLL,
  REQUEST_SCRIPT_LIST_BY_SCROLL_SUCCESS,
  REQUEST_SCRIPT_LIST_BY_SCROLL_FAILURE,
  SELECT_SCRIPT,
  REQUEST_PREFERENCE_BY_BANNER,
  REQUEST_PREFERENCE_BY_BANNER_FAILURE,
  REQUEST_PREFERENCE_BY_BANNER_SUCCESS,
  REQUEST_CONFIG_LIST,
  REQUEST_CONFIG_LIST_SUCCESS,
  REQUEST_CONFIG_LIST_FAILURE,
  REQUEST_PUT_SCRIPT_FAILURE,
  REQUEST_PUT_SCRIPT_SUCCESS,
  REQUEST_PUT_SCRIPT,
} from 'redux/actions/types';

/**
 * Library Notification (persist)
 */
import {
  ADD_WAITING_LIBRARY_JOB_ID,
  DELETE_WAITING_LIBRARY_JOB_ID,
  COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST,
} from 'redux/actions/types';

/**
 * Notification
 */
import {
  ENQUEUE_SNACKBAR,
  ENQUEUE_SNACKBAR_LIST,
  CLOSE_SNACKBAR,
  REMOVE_SNACKBAR,
} from 'redux/actions/types';

/**
 * WKBL VIDEO
 */
import {
  ADD_DOWNLOADING_GROUP,
  REMOVE_DOWNLOADING_GROUP,
  UPDATE_DOWNLOADING_GROUP,
} from 'redux/actions/types';

/**
 * WKBL VIDEO
 */
import {
  ADD_DOWNLOADING_GROUP_SPECIAL,
  REMOVE_DOWNLOADING_GROUP_SPECIAL,
  UPDATE_DOWNLOADING_GROUP_SPECIAL,
} from 'redux/actions/types';

import LibraryParamVO from 'commons/vo/param/LibraryParamVO';
import ScriptParamVO, { ScriptPutParamVOProps } from 'commons/vo/param/ScriptParamVO';
import ScriptVO from 'commons/vo/Script';
import WkblVideoParamVO from 'commons/vo/param/WkblVideoParamVO';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import CodeVO from 'commons/vo/CodeVO';
import AssetParamVO from 'commons/vo/param/AssetParamVO';
import AssetVO from 'commons/vo/AssetVO';
import CategoryVO from 'commons/vo/CategoryVO';
import LibraryVO from 'commons/vo/Library';
import WkblScriptParamVO from 'commons/vo/param/WkblScriptParamVO';
import WkblScriptVO from 'commons/vo/WkblScriptVO';
import StorageVO from 'commons/vo/StorageVO';
import UserVO from 'commons/vo/UserVO';
import QuarterVO from 'commons/vo/QuarterVO';
import TeamVO from 'commons/vo/TeamVO';
import SnackbarNotification from 'commons/vo/SnackbarNotification';
import { VariantType } from 'notistack';
import { PreviewParamProps } from 'pages/type';

import KeyFlowError from 'commons/framework/KeyFlowError';
import PreferenceVO from 'commons/vo/PreferenceVO';
import ConfigVO from 'commons/vo/ConfigVO';
import MediaconvertJobVO from 'commons/vo/MediaconvertJob/MediaconvertJob';
import { HandleDownload } from 'commons/framework/aws/type';
import { fromPairs } from 'lodash';

export const openModal = createAction<{ body: JSX.Element }, typeof OPEN_MODAL>(OPEN_MODAL);
export const closeModal = createAction(CLOSE_MODAL);

/**
 * [1]  로그인, 로그아웃 등 User 관련 액션
 */
export const requestLogin = createAction<
  { userId: string; password: string },
  typeof REQUEST_LOGIN
>(REQUEST_LOGIN);

export const requestLoginSuccess = createAction<{ user: UserVO }, typeof REQUEST_LOGIN_SUCCESS>(
  REQUEST_LOGIN_SUCCESS,
);

export const requestLoginFailure = createAction<
  { errorMessage: string },
  typeof REQUEST_LOGIN_FAILURE
>(REQUEST_LOGIN_FAILURE);

export const requestLogout = createAction(REQUEST_LOGOUT);
export const requestLogoutSuccess = createAction(REQUEST_LOGOUT_SUCCESS);
export const requestLogoutFailure = createAction(REQUEST_LOGOUT_FAILURE);

export const requestAuthentication = createAction<{ url: string }, typeof REQUEST_AUTHENTICATION>(
  REQUEST_AUTHENTICATION,
);
export const requestAuthenticationSuccess = createAction(REQUEST_AUTHENTICATION_SUCCESS);
export const requestAuthenticationFailure = createAction(REQUEST_AUTHENTICATION_FAILURE);

/**
 * [3] 스토리지 관련 액션
 */
export const requestStorageList = createAction(REQUEST_STORAGE_LIST);
export const requestStorageListSuccess = createAction<
  { storageList: StorageVO[] },
  typeof REQUEST_STORAGE_LIST_SUCCESS
>(REQUEST_STORAGE_LIST_SUCCESS);
export const requestStorageListFailure = createAction(REQUEST_STORAGE_LIST_FAILURE);

/**
 * [4] 카테고리 관련 액션
 */
export const requestCategoryList = createAction(REQUEST_CATEGORY_LIST);
export const requestCategoryListSuccess = createAction<
  { categoryList: CategoryVO[] },
  typeof REQUEST_CATEGORY_LIST_SUCCESS
>(REQUEST_CATEGORY_LIST_SUCCESS);
export const requestCategoryListFailure = createAction(REQUEST_CATEGORY_LIST_FAILURE);

/**
 * [5] WKBL Script 관련 액션
 */
export const requestWkblScriptList = createAction<
  { param: WkblScriptParamVO },
  typeof REQUEST_WKBL_SCRIPT_LIST
>(REQUEST_WKBL_SCRIPT_LIST);
export const requestWkblScriptListSuccess = createAction<
  {
    wkblScriptList: WkblScriptVO[];
    pagination: PaginationType;
    returnCount: number;
  },
  typeof REQUEST_WKBL_SCRIPT_LIST_SUCCESS
>(REQUEST_WKBL_SCRIPT_LIST_SUCCESS);
export const requestWkblScriptListFailure = createAction(REQUEST_WKBL_SCRIPT_LIST_FAILURE);
export const clearWkblScriptList = createAction(CLEAR_WKBL_SCRIPT_LIST);

export const changeWkblScriptPage = createAction<
  { pageNumber: number },
  typeof CHANGE_WKBL_SCRIPT_PAGE
>(CHANGE_WKBL_SCRIPT_PAGE);
export const changeWkblScriptSort = createAction<
  { sort: SortType },
  typeof CHANGE_WKBL_SCRIPT_SORT
>(CHANGE_WKBL_SCRIPT_SORT);
export const changeWkblScriptAsc = createAction<{ asc: AscType }, typeof CHANGE_WKBL_VIDEO_ASC>(
  CHANGE_WKBL_VIDEO_ASC,
);
export const changeWkblScriptReturnCount = createAction<
  { returnCount: number },
  typeof CHANGE_WKBL_SCRIPT_RETURN_COUNT
>(CHANGE_WKBL_SCRIPT_RETURN_COUNT);

/**
 * Library Notification (persist)
 */
export const addWaitingLibraryJobId = createAction<{
  addIdList: { [key: number]: KeyFlowLibraryStatus };
  userId: string;
}>(ADD_WAITING_LIBRARY_JOB_ID);
export const deleteWaitingLibraryJobId = createAction<{
  deleteIdList: { [key: number]: KeyFlowLibraryStatus };
  userId: string;
}>(DELETE_WAITING_LIBRARY_JOB_ID);
export const compareJobStatusAfterRequestLibraryList = createAction<
  { param: LibraryParamVO },
  typeof COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST
>(COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST);

/**
 * [] script 관련 액션
 */
export const requestScriptList = createAction<{ param: ScriptParamVO }, typeof REQUEST_SCRIPT_LIST>(
  REQUEST_SCRIPT_LIST,
);
export const requestScriptListSuccess = createAction<
  { scriptList: ScriptVO[]; pagination: PaginationType; keyword: string },
  typeof REQUEST_SCRIPT_LIST_SUCCESS
>(REQUEST_SCRIPT_LIST_SUCCESS);
export const requestScriptListFailure = createAction(REQUEST_SCRIPT_LIST_FAILURE);

export const requestScriptListByScroll = createAction<
  { param: ScriptParamVO },
  typeof REQUEST_SCRIPT_LIST_BY_SCROLL
>(REQUEST_SCRIPT_LIST_BY_SCROLL);
export const requestScriptListByScrollSuccess = createAction<
  { scriptList: ScriptVO[]; pagination: PaginationType },
  typeof REQUEST_SCRIPT_LIST_BY_SCROLL_SUCCESS
>(REQUEST_SCRIPT_LIST_BY_SCROLL_SUCCESS);
export const requestScriptListByScrollFailure = createAction(REQUEST_SCRIPT_LIST_BY_SCROLL_FAILURE);
export const selectScript = createAction<{ script: ScriptVO }, typeof SELECT_SCRIPT>(SELECT_SCRIPT);

export const requestPutScript = createAction<
  { param: ScriptPutParamVOProps },
  typeof REQUEST_PUT_SCRIPT
>(REQUEST_PUT_SCRIPT);

export const requestPutScriptSuccess = createAction<
  { script: ScriptVO },
  typeof REQUEST_PUT_SCRIPT_SUCCESS
>(REQUEST_PUT_SCRIPT_SUCCESS);

export const requestPutScriptFailure = createAction(REQUEST_PUT_SCRIPT_FAILURE);

/**
 * [] WKBL 비디오 조회 관련 액션
 */
export const requestWkblVideoList = createAction<
  { param: WkblVideoParamVO },
  typeof REQUEST_WKBL_VIDEO_LIST
>(REQUEST_WKBL_VIDEO_LIST);
export const requestWkblVideoListSuccess = createAction<
  { videoList: WkblVideoVO[]; pagination: PaginationType; returnCount: number },
  typeof REQUEST_WKBL_VIDEO_LIST_SUCCESS
>(REQUEST_WKBL_VIDEO_LIST_SUCCESS);
export const requestWkblVideoListFailure = createAction(REQUEST_WKBL_VIDEO_LIST_FAILURE);
export const clearWkblVideoList = createAction(CLEAR_WKBL_VIDEO_LIST);
export const changeWkblVideoSeason = createAction<
  { season: string },
  typeof CHANGE_WKBL_VIDEO_SEASON
>(CHANGE_WKBL_VIDEO_SEASON);
export const changeWkblVideoGameType = createAction<
  { gameType: number },
  typeof CHANGE_WKBL_VIDEO_GAME_TYPE
>(CHANGE_WKBL_VIDEO_GAME_TYPE);
export const changeWkblVideoGameDateFrom = createAction<
  { gameDateFrom: string },
  typeof CHANGE_WKBL_VIDEO_GAME_DATE_FROM
>(CHANGE_WKBL_VIDEO_GAME_DATE_FROM);
export const changeWkblVideoGameDateTo = createAction<
  { gameDateTo: string },
  typeof CHANGE_WKBL_VIDEO_GAME_DATE_TO
>(CHANGE_WKBL_VIDEO_GAME_DATE_TO);
export const changeWkblVideoPage = createAction<
  { pageNumber: number },
  typeof CHANGE_WKBL_VIDEO_PAGE
>(CHANGE_WKBL_VIDEO_PAGE);
export const changeWkblVideoSort = createAction<{ sort: SortType }, typeof CHANGE_WKBL_VIDEO_SORT>(
  CHANGE_WKBL_VIDEO_SORT,
);
export const changeWkblVideoAsc = createAction<{ asc: AscType }, typeof CHANGE_WKBL_VIDEO_ASC>(
  CHANGE_WKBL_VIDEO_ASC,
);
export const changeWkblVideoReturnCount = createAction<
  { returnCount: number },
  typeof CHANGE_WKBL_VIDEO_RETURN_COUNT
>(CHANGE_WKBL_VIDEO_RETURN_COUNT);

/**
 *  WKBL Video Downloading
 */
export const addDownloadingGroup = createAction<{ id: number }, typeof ADD_DOWNLOADING_GROUP>(
  ADD_DOWNLOADING_GROUP,
);
export const removeDownloadingGroup = createAction<{ id: number }, typeof REMOVE_DOWNLOADING_GROUP>(
  REMOVE_DOWNLOADING_GROUP,
);
export const updateDownloadingGroup = createAction<
  { id: number; percent: number },
  typeof UPDATE_DOWNLOADING_GROUP
>(UPDATE_DOWNLOADING_GROUP);
/**
 *  WKBL Special Video Downloading
 */
export const addDownloadingGroupSpecial = createAction<
  { id: number },
  typeof ADD_DOWNLOADING_GROUP_SPECIAL
>(ADD_DOWNLOADING_GROUP_SPECIAL);
export const removeDownloadingGroupSpecial = createAction<
  { id: number },
  typeof REMOVE_DOWNLOADING_GROUP_SPECIAL
>(REMOVE_DOWNLOADING_GROUP_SPECIAL);
export const updateDownloadingGroupSpecial = createAction<
  { id: number; percent: number },
  typeof UPDATE_DOWNLOADING_GROUP_SPECIAL
>(UPDATE_DOWNLOADING_GROUP_SPECIAL);

/**
 * [] WKBL 스페셜 영상 조회 관련 액션
 */
export const requestWkblSpecialVideoList = createAction<
  { param: WkblVideoParamVO },
  typeof REQUEST_WKBL_SPECIAL_VIDEO_LIST
>(REQUEST_WKBL_SPECIAL_VIDEO_LIST);
export const requestWkblSpecialVideoListSuccess = createAction<
  {
    specialVideoList: WkblVideoVO[];
    pagination: PaginationType;
    returnCount: number;
  },
  typeof REQUEST_WKBL_SPECIAL_VIDEO_LIST_SUCCESS
>(REQUEST_WKBL_SPECIAL_VIDEO_LIST_SUCCESS);
export const requestWkblSpecialVideoListFailure = createAction(
  REQUEST_WKBL_SPECIAL_VIDEO_LIST_FAILURE,
);
export const clearWkblSpecialVideoList = createAction(CLEAR_WKBL_SPECIAL_VIDEO_LIST);

export const changeWkblSpecialVideoPage = createAction<
  { pageNumber: number },
  typeof CHANGE_WKBL_SPECIAL_VIDEO_PAGE
>(CHANGE_WKBL_SPECIAL_VIDEO_PAGE);
export const changeWkblSpecialVideoSort = createAction<
  { sort: SortType },
  typeof CHANGE_WKBL_SPECIAL_VIDEO_SORT
>(CHANGE_WKBL_SPECIAL_VIDEO_SORT);
export const changeWkblSpecialVideoAsc = createAction<
  { asc: AscType },
  typeof CHANGE_WKBL_SPECIAL_VIDEO_ASC
>(CHANGE_WKBL_SPECIAL_VIDEO_ASC);
export const changeWkblSpecialVideoReturnCount = createAction<
  { returnCount: number },
  typeof CHANGE_WKBL_SPECIAL_VIDEO_RETURN_COUNT
>(CHANGE_WKBL_SPECIAL_VIDEO_RETURN_COUNT);

/**
 * [] 코드 조회 관련 액션
 */
export const requestCodeList = createAction(REQUEST_CODE_LIST);
export const requestCodeListSuccess = createAction<
  {
    videoTypeList: CodeVO[];
    wkblGameTypeList: CodeVO[];
    kfScriptRefRangeList: CodeVO[];
    wkblSeasonList: CodeVO[];
    kfScriptTypeList: CodeVO[];
  },
  typeof REQUEST_CODE_LIST_SUCCESS
>(REQUEST_CODE_LIST_SUCCESS);
export const requestCodeListFailure = createAction(REQUEST_CODE_LIST_FAILURE);

/**
 * [] 환경 설정
 */
export const requestPreferenceList = createAction<
  { groupNames: string[] },
  typeof REQUEST_PREFERENCE_LIST
>(REQUEST_PREFERENCE_LIST);
export const requestPreferenceListSuccess = createAction<
  {
    video: Map<string, PreferenceVO>;
    videoLibrary: Map<string, PreferenceVO>;
  },
  typeof REQUEST_PREFERENCE_LIST_SUCCESS
>(REQUEST_PREFERENCE_LIST_SUCCESS);
export const requestPreferenceListFailure = createAction(REQUEST_PREFERENCE_LIST_FAILURE);

/**
 * [] 환경설정 (Banner)
 *  로그인 페이지에서 사용해야 할 환경설정이기 때문에 인증을 거치지 않는다.
 */
export const requestPreferenceByBanner = createAction(REQUEST_PREFERENCE_BY_BANNER);
export const requestPreferenceByBannerSuccess = createAction<
  {
    banner: Map<string, PreferenceVO>;
  },
  typeof REQUEST_PREFERENCE_BY_BANNER_SUCCESS
>(REQUEST_PREFERENCE_BY_BANNER_SUCCESS);
export const requestPreferenceByBannerFailure = createAction(REQUEST_PREFERENCE_BY_BANNER_FAILURE);

/**
 * [] Web Client Back-end 설정
 */
export const requestConfigList = createAction(REQUEST_CONFIG_LIST);
export const requestConfigListSuccess = createAction<
  {
    config: ConfigVO;
  },
  typeof REQUEST_CONFIG_LIST_SUCCESS
>(REQUEST_CONFIG_LIST_SUCCESS);
export const requestConfigListFailure = createAction(REQUEST_CONFIG_LIST_FAILURE);

/**
 * [] 팀
 */
export const requestTeamList = createAction<{ teamIdList: number[] }, typeof REQUEST_TEAM_LIST>(
  REQUEST_TEAM_LIST,
);
export const requestTeamListSuccess = createAction<
  {
    teamList: TeamVO[];
  },
  typeof REQUEST_TEAM_LIST_SUCCESS
>(REQUEST_TEAM_LIST_SUCCESS);
export const requestTeamListFailure = createAction(REQUEST_TEAM_LIST_FAILURE);

/**
 * [] 비디오 플레이어 관련 액션
 */
export const initVideo = createAction<{ fps: number }, typeof INIT_VIDEO>(INIT_VIDEO);
export const changeVideoInTime = createAction<{ inTime: number }, typeof CHANGE_VIDEO_IN_TIME>(
  CHANGE_VIDEO_IN_TIME,
);
export const changeVideoOutTime = createAction<{ outTime: number }, typeof CHANGE_VIDEO_OUT_TIME>(
  CHANGE_VIDEO_OUT_TIME,
);
export const changeVideoDuration = createAction<{ duration: number }, typeof CHANGE_VIDEO_DURATION>(
  CHANGE_VIDEO_DURATION,
);
export const changeVideoCurrentTime = createAction<
  { currentTime: number },
  typeof CHANGE_VIDEO_CURRENT_TIME
>(CHANGE_VIDEO_CURRENT_TIME);

export const throwError = createAction<{ error: Error | KeyFlowError }, typeof THROW_ERROR>(
  THROW_ERROR,
);
export const clearError = createAction(CLEAR_ERROR);

/**
 * SnackbarNotification
 */
// TODO : 단일 노티 액션도 파라미터를 Model 로 받도록 수정해야함.
export const enqueueSnackbar = createAction<
  { messages: string[]; options: { variant: VariantType } },
  typeof ENQUEUE_SNACKBAR
>(ENQUEUE_SNACKBAR);

export const enqueueSnackbarList = createAction<
  Array<SnackbarNotification>,
  typeof ENQUEUE_SNACKBAR_LIST
>(ENQUEUE_SNACKBAR_LIST);
export const closeSnackbar = createAction(CLOSE_SNACKBAR);
export const removeSnackbar = createAction<{ key: number }, typeof REMOVE_SNACKBAR>(
  REMOVE_SNACKBAR,
);
